<h1>{{"navigation.catalog" | translate}}</h1>
<div *ngFor="let itemGroup of itemGroups">
  <h2>{{itemGroup.title | translate}}</h2>
  <div class="container-card d-flex" *ngIf="itemGroup">
      <div *ngFor="let item of itemGroup.items" class="catalogue-card">
          <app-catalogue-item [item]="item" style="height: 280px;"></app-catalogue-item>
      </div>
  </div>
  <div class="header d-flex">
    <div class="flex-grow-1"></div>
    <a href="http://katalog.hecht-kontaktlinsen.de/de/catalog/de" target="_blank">{{'home.catalog.seeMore' | translate }}<fa-icon [icon]="arrow"></fa-icon></a>
  </div>
</div>
